import Upload from './Upload'

/* import compose from 'recompose/compose'
import withState from 'recompose/withState'

import withUploadFile from './withUploadFile'

export default compose(
  withState('templateName', 'setTemplateName', ''),
  withState('file', 'setFile', null),
  withUploadFile
)(Upload) */
module.exports = Upload



// WEBPACK FOOTER //
// ./src/components/UploadTemplate/index.js